// Shared plan-tier classifier for the bts-2026-freemium gates. Derives the
// user's plan from LaunchDarkly's identify state plus the subscription/trial
// booleans, with no knowledge of any surface's flag or treatment. Both the
// export gate (resolveExportGate) and the My Resources age gate
// (resolveResourceGateMode) build on this, so the free/trial/paid boundary —
// and the "inert until identified" rule — is defined in exactly one place.
//
// Returns:
//   'unknown' — LD has not identified the real user yet (treat as a no-op)
//   'paid'    — active subscription
//   'trial'   — free trial in progress
//   'free'    — no subscription, no trial
//
// `isPremiumUser` is deliberately NOT an input: it collapses paid + trial into
// one boolean, which these gates must be able to tell apart.
export const resolvePlanTier = ({ isLDidentified, hasActiveSubscription, isFreeTrialUser }) => {
  if (!isLDidentified) return 'unknown';
  if (hasActiveSubscription) return 'paid';
  if (isFreeTrialUser) return 'trial';
  return 'free';
};
